import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AppMenuitemComponent } from './app.menuitem.component';

@Component({
  selector: 'app-menu',
  standalone: true,
  templateUrl: './app.menu.component.html',
  imports: [CommonModule, AppMenuitemComponent],
})
export class AppMenuComponent {
  menuItems: MenuItem[] = [
    {
      label: 'Etiquetas',
      items: [{ label: 'Generar etiquetas', icon: 'pi pi-fw pi-tags', routerLink: ['/dashboard'] }],
    },
    {
      label: 'Importar',
      items: [
        {
          label: 'Importar Pedidos de Compra',
          icon: 'pi pi-fw pi-chart-bar',
          routerLink: ['import'],
        },
      ],
    },
    {
      label: 'Fidelidad CASA',
      items: [
        {
          label: 'Dar de alta tarjeta de fidelidad física de CASA',
          icon: 'pi pi-fw pi-credit-card',
          routerLink: ['fidelity'],
        },
      ],
    },
  ];
}
